import React from 'react';

import { FormControl, Tooltip } from 'native-base';
import { Text } from "../Typography/Text";

export { FormControl };

const Label = FormControl.Label;
const RenderWithoutTooltip = ({ children }) => {
    return <React.Fragment>{children}</React.Fragment>;
};

FormControl.Label = ({ label, tooltip, ...props }) => {
    const TooltipComponent = tooltip ? Tooltip : RenderWithoutTooltip;
    const children = props.children || label || null;
    return (
        <Text>
            <TooltipComponent label={tooltip} hasArrow placement="top">
                <Label
                    {...props}
                    display="inline"
                    accessibilityLabel={children ? " " : undefined}
                    _text={{ color: props.color, ...props._text, ...props.text, whiteSpace: 'pre-wrap' }}
                    width="max-content"
                    maxWidth="100%"
                >
                    {children}
                </Label>
            </TooltipComponent>
        </Text>
    );
};
